module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-194.46b17c2.woff2";